// extracted by mini-css-extract-plugin
export var error = "styles-module--error--d840c";
export var iconBlock = "styles-module--iconBlock--65e9d";
export var success = "styles-module--success--497d6";
export var toast = "styles-module--toast--00eee";
export var toastContent = "styles-module--toastContent--1211f";
export var toastIcon = "styles-module--toastIcon--dc68f";